export function checkHttp(url) {
  if (url) {
    if (/^((http|https):\/\/)|(\/\/)/.test(url)) {
      return url
    } else {
      return '//' + url
    }
  } else {
    return url
  }
}
// 检查是否含有域名
export function checkQiNiuUrl(url, query) {
  if (url) {
    if (Array.isArray(url)) {
      return url.map(item => {
        if (/^blob:(http|https):\/\//.test(url)) {
          return url
        } if (/^http(s?):\/\/((fileqn|apkqn)\.anttalk\.vip|qiniufile\.xdaocloud\.com)\//.test(item)) {
          return item + (query || '')
        } else {
          return ('https://fileqn.anttalk.vip' + item + (query || ''))
        }
      })
    } else {
      if (/^blob:(http|https):\/\//.test(url)) {
        return url
      } else if (/^http(s?):\/\/((fileqn|apkqn)\.anttalk\.vip|qiniufile\.xdaocloud\.com)\//.test(url)) {
        return url + (query || '')
      } else {
        return ('https://fileqn.anttalk.vip' + url + (query || ''))
      }
    }
  } else {
    return url
  }
}
// 移除 七牛域名
export function removeQiNiuUrl(url) {
  if (url) {
    return url.replace(/^http(s?):\/\/((fileqn|apkqn)\.anttalk\.vip|qiniufile\.xdaocloud\.com)\//, '')
  } else {
    return ''
  }
}
